<template>
  <div class="png2-bottom">
    <div class="mb-6" v-for="(block, ind) in blocks" :key="ind">
      <div class="png2-block__row">
        <div
          class="png2-block__item"
          v-for="(item, iInd) in block.blocks"
          :key="iInd"
        >
          <div class="png2-block__item-content">
            <div class="png2-block__item-title" v-html="item.title"></div>
            <input
              type="checkbox"
              :id="`png2_opener_${ind}_${iInd}`"
              v-if="item && item.tip"
            />
            <div class="png2-block__item-tip" v-if="item && item.tip">
              <img :src="item.tip" alt="" />
            </div>
            <label
              :for="`png2_opener_${ind}_${iInd}`"
              v-if="item && item.tip"
              class="png2-block__item-button button button_small button_empty-pink d-inline-flex ml-auto"
            >
              <span class="open">Проверить себя</span>
              <span class="close">Cкрыть</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5 5.5L8.5 10.5L3.5 5.5"
                  stroke="#830051"
                  stroke-linecap="square"
                />
              </svg>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PNGDropdownFirst",
  computed: {
    blocks() {
      return [
        {
          blocks: [
            {
              title: "Селекция клеток ПНГ в пораженном костном мозге",
              tip: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/png/tip.png`,
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.png2-bottom {
  margin-top: 32px;
  &__title {
    padding: 8px 16px;
    background-color: #8a7098;
    color: #fff;
    text-align: center;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
}
.png2-block {
  &__row {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 32px;

    @media screen and (max-width: 767px) {
      padding: 16px 0 0;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 72px;

    &-arrow {
      width: fit-content;
      margin: 0 auto;

      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &-content {
      position: relative;
      border: 1px solid #fff;
      padding: 24px;
      color: #3c4242;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      height: 100%;
    }

    &-title {
      font-weight: 500;
      @media screen and (max-width: 1199px) {
        max-width: 380px;
      }
    }

    &-tip {
      max-height: 0;
      transition: 0.3s;
      overflow: hidden;
    }

    & input {
      display: none;
    }

    & input {
      &:checked {
        & ~ .png2-block {
          &__item {
            &-tip {
              margin-top: 8px;
              max-height: 1500px;
              margin-bottom: 40px;
              @media screen and (max-width: 767px) {
                margin-bottom: 0;
              }
            }
            &-button {
              margin-top: 16px;
              & .open {
                display: none;
              }
              & .close {
                display: block;
              }
              & svg {
                transform: rotate(-180deg);
              }
            }
          }
        }
      }
    }

    &-button {
      margin-top: auto;
      position: absolute;
      right: 24px;
      bottom: 24px;
      & .open {
        display: block;
      }
      & .close {
        display: none;
      }
      & svg {
        transform: rotate(0deg);
        transition: 0.3s;
        margin-left: 4px;
      }
      @media screen and (max-width: 767px) {
        margin-top: 16px;
        position: static;
      }
    }

    &:first-child {
      .png2-block {
        &__item {
          &-content {
            border-color: #b19fba;
          }
        }
      }
    }

    &:last-child {
      .png2-block {
        &__item {
          &-content {
            border-color: #d2d2d2;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.png2-block__item {
  & sup {
    color: inherit !important;
  }
}
</style>
